import { useEffect, useState } from 'react'
import { sessionStorageHelper } from '@utils/localStorageHelper'

interface PaginationHistoryParams {
  id?: string
  collectionName?: string | string[]
  locale?: string
  queryString: string
  slug?: string | string[]
}
export const usePaginationHistory = ({ id, collectionName, locale, queryString, slug }: PaginationHistoryParams) => {
  const [pageState, setPageState] = useState(parseFloat('1'))
  const [activePages, setActivePages] = useState(1)
  const [lastCategory, setLastCategory] = useState(slug)

  useEffect(() => {
    const savedPage = parseInt(sessionStorageHelper.get('categoryPage') || '1')
    const savedActivePages = parseInt(sessionStorageHelper.get('categoryActivePages') || '1')
    const savedLastPage = sessionStorageHelper.get('lastCategoryPages') || ''

    if (!isNaN(savedPage)) setPageState(savedPage)
    if (!isNaN(savedActivePages)) setActivePages(savedActivePages)
    setLastCategory(savedLastPage)
  }, [])

  useEffect(() => {
    sessionStorageHelper.set('categoryPage', pageState.toString())
    sessionStorageHelper.set('categoryActivePages', activePages.toString())
  }, [pageState, activePages])

  useEffect(() => {
    if (!slug) return
    sessionStorageHelper.set('lastCategoryPages', slug)
  }, [slug])

  return {
    pageState,
    setPageState,
    activePages,
    setActivePages,
    lastCategory,
  }
}
